module.exports = "<ng-content></ng-content>\r\n"